<template>
	<!-- 资讯 -->
	<div class="news">
		<div class="info newsInfo">
			<div class="news-head flexItems flexBetween">
				<div class="indexTitle">
					<p class="flexItems"><span></span>资讯</p>
					<p>News</p>
				</div>
				<router-link to="../news" class="flexItems">查看所有&gt;</router-link>
			</div>
			<div class="news-swiper">
				<swiper ref="mySwiper" :options="swiperOptions">
					<swiper-slide v-for="(item,index) in newslist" :key="item.id" class="news-swiper-slide">
						<div class="new-item">
						<router-link :to="{path:'../newsdetail',query:{id:item.id}}">
						<div class="news-item-img"><img :src="item.url" alt=""/></div>
						<div class="swiper-slide-text">
							<p>{{item.title}}</p>
							<p>{{item.create_time}}</p>
						</div>
						<div class="swiper-slide-more flexItems flexBetween">
							<router-link :to="{path:'../newsdetail',query:{id:item.id}}">查看更多 &gt;</router-link>
							<span>0{{index+1}}</span>
						</div>
						</router-link>
						</div>
					</swiper-slide>
				</swiper>
			</div>
			<div class="news-button flex">
				<div class="swiper-button-prev"><i class="el-icon-arrow-left"></i></div>
				<div class="swiper-button-next"><i class="el-icon-arrow-right"></i></div>
			</div>
		</div>
	
		<!-- 手机端 -->
		<div class="phone-news">
			<div class="indexTitle">
				<p class="flexItems"><span></span>资讯</p>
				<p>News</p>
			</div>
			<div class="phone-news-list">
				<router-link class="phone-news-item flexItems" :to="{path:'../newsdetail',query:{id:item.id}}" v-for="(item,index) in newslist" :key="item.id">
					<div class="phone-news-item-img">
						<img :src="item.url" alt="">
					</div>
					<div class="phone-news-item-text">
						{{item.title}}
					</div>
				</router-link>
				<router-link to="../news" class="findMore">查看更多&gt;</router-link>
			</div>
			
		</div>
		<span class="zmldown2"></span>
	</div>
</template>
<script>
	import {getTypeNewsList} from '@/api/api'
	import axios from 'axios'
	export default{
		data(){
		  return{
			swiperOptions: {
				speed:1500,
				slidesPerView: 3,
				spaceBetween: 80,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			},
			newslist:[],
		  }
		},
		computed:{
			swiper(){
			  return this.$refs.mySwiper.$swiper;
			}
		},
		mounted() {
			this._getnewslist('',1);
		},
		methods:{
			_getnewslist(id,page){
				getTypeNewsList(id,page).then((res)=>{
					// console.log(res.data)
					if(res.data.code == 200){
						this.newslist = res.data.data.list
					}else{
						console.log("无数据")
					}
				}).catch((err)=>{
					console.log("请求失败",err)
				})
			}
		}
	}
</script>
<style scoped="scoped">
.news{
	width: 100%;
	height: 100%;
	background-color: #fff;
}
.newsInfo{
	padding-top: 120px;
}
.news-head>a{
	white-space: nowrap;
	color: #999;
	font-size: 14px;
}
.news-swiper{
	margin-top: 80px;
}
.swiper-container{
	overflow: inherit;
}
.swiper-slide{
	width: 419px !important;
	cursor: pointer;
	transition: .5s;
}
.news-swiper-slide:hover{
	transform: translateY(-40px);
}
.news-swiper-slide:hover .news-item-img{
	box-shadow: 0px 5px 10px 0px rgba(0,0,0,.4);
	/* width: 105%; */
}
.news-swiper-slide{
	width: 380px;
	height: 409px;
}
.new-item:hover{
	width: 370px;
	height: 399px;
}
.new-item{
    width: 360px;
	height: 389px;
}
.news-item-img{
	width: 100%;
	height: 250px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background-color: #efefef;
	transition: .3s;
}
img{
	width: 100%;
	height: 100%;
	margin-right: 0 !important;
}
.news-button{
	margin-top: 60px;
	position: relative;
	height: 70px;
}
.swiper-button-next,
.swiper-button-prev{
	width: 70px;
	height: 70px;
	position: static;
	margin-top: 0;
	background-color: #ECF1F8;
	outline: none;
	font-size: 35px;
	color: #ADADB0;
	font-weight: bold;
	transition: .3s;
	margin-right: 40px;
	background-image: url();
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 1;
}
.swiper-button-next{
	background-color: #127BFD;
	color: #fff;
}
.swiper-button-prev:after, 
.swiper-button-next:after{
	content: "";
}

@media only screen and (max-width: 1600px){
	.news-swiper{
		margin-top: 40px;
	}
	.swiper-slide{
		width: 360px !important;
	}
	.news-item-img{
		height: 165px;
	}
	.swiper-slide-text p:nth-of-type(1){
		/* overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap; */
		display:-webkit-box;
		-webkit-box-orient:vertical;
		-webkit-line-clamp: 2; 
		overflow:hidden;
	}
	.news-button{
		margin-top: 20px;
	}
	.newsInfo{
		display: flex;
		flex-flow: column;
		justify-content: space-around;
	}
}

@media only screen and (max-width: 750px){
	.newsInfo{
		display: none;
	}
	.phone-news-list{
		padding: 0px 23px;
		/* padding-top: 94px; */
		overflow-y: auto;
		height: 100%;
		padding-top: 74px;
	}
	.phone-news-item{
		width: 100%;
		height: auto;
		margin-bottom: 10px;
		color: #282828;
	}
	.phone-news-item-img{
		width: 110px;
		height: 66px;
		overflow: hidden;
		display: flex;
		align-items: center;
	}
	.phone-news-item-img img{
		height: 100%;
	}
	.phone-news-item-text{
		font-size: 16px;
		padding-left: 10px;
		flex: 1;
		line-height: 22px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient:vertical;
		-webkit-line-clamp:2;
	}
	.findMore{
		display: block;
		width: 100%;
		height: auto;
		line-height: 40px;
		border: 1px solid #ccc;
		text-align: center;
		border-radius: 20px;
		color: #999;
		font-size: 12px;
		margin-top: 30px;
	}
}

@media only screen and (max-width: 320px){
	.phone-news-item-img{
		height: 50px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/index_news.vue